var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VForm',{ref:"form"},[_c('VFileInput',{attrs:{"label":"Upload","rules":[_vm.validation.required]},on:{"change":_vm.emit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }